import repositories from '..';

const resource = '/master/activity-classes';

export default {
  getInitData: () => repositories.get(`${resource}/data/init`),
};
